module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img_0.711daccb.png";